/*******************************************************
* Component Name
* 
* [Brief 1-3 sentence description of the component's main purpose and functionality]
* 
* Key Features:
* - [Core capability 1]
* - [Core capability 2]
* - [Core capability 3]
********************************************************/
'use client';
//########## IMPORTS ##########
// #region IMPORTS
import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText,
    Box,
    Button,
    Typography,
    Slide,
} from '@mui/material';
import { type TransitionProps } from '@mui/material/transitions';
import Image from 'next/image';
import swishLogo from '@/public/assets/media/Logos/swish.png';
import FormAccountReq from './FormAccountReq';
// #endregion


//########## TYPE DEFINITIONS ##########
//#region TYPE DEFINITIONS
interface AccountReqDialogProps {
    open: boolean;
    handleClose: () => void;
    setMainDialogOpen: (open: boolean) => void;
}

//#endregion


//########## CONSTANTS & Global Variables ##########
//#region CONSTANTS
const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const dialogStyles = {
    '& .MuiDialog-container': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    '& .MuiDialog-paper': {
        m: 2,
        maxWidth: 'phoneBig',
        width: '100%'
    }
}

//#endregion


//########## FUNCTIONS ##########
// #region FUNCTIONS

//#endregion


export default function AccountReqDialog({ open, handleClose: onClose, setMainDialogOpen }: AccountReqDialogProps) {
    //########## MAIN LOGIC ##########
    // #region MAIN LOGIC

    const [successDialog, setSuccessDialog] = useState({
        open: false,
        message: ''
    });

    const handleClose = () => {
        setMainDialogOpen(false);
        onClose();
    };

    const handleSuccessDialogClose = () => {
        setSuccessDialog({ open: false, message: '' });
        handleClose();
    };

    const handleSuccess = (message: string) => {
        setMainDialogOpen(false);
        setSuccessDialog({
            open: true,
            message
        });
    };
    //#endregion


    //########## MARKDOWN ##########
    // #region MARKDOWN
    return (
        <>
            <Dialog
                open={open}
                onClose={(_event, reason) => {
                    if (reason === 'backdropClick') {
                        return;
                    }
                    handleClose();
                }}
                sx={dialogStyles}
                fullWidth
            >
                <DialogTitle sx={{ textAlign: 'center', pb: 0 }}>
                    {/* Logo and Title */}
                    <Box sx={{ display: 'flex', alignItems: 'center', mr: 4 }}>
                        <Box sx={{ width: 40, height: 40, position: 'relative', mr: 2 }}>
                            <Image
                                src={swishLogo}
                                alt="Swish Logo"
                                fill
                                style={{ objectFit: 'contain' }}
                                priority
                            />
                        </Box>
                        <Typography variant="h6" noWrap component="div">
                            Account Request Form
                        </Typography>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <FormAccountReq
                        handleSuccess={handleSuccess}
                        handleCancel={handleClose}
                    />
                </DialogContent>
            </Dialog>

            {/* Success Dialog */}
            <Dialog
                open={successDialog.open}
                keepMounted
                onClose={handleSuccessDialogClose}
                aria-describedby="alert-dialog-success-description"
                slots={{
                    transition: Transition
                }}
                sx={{
                    '& .MuiDialog-container': {
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    },
                    '& .MuiDialog-paper': {
                        m: 2,
                        maxWidth: 'phoneBig',
                        width: '100%'
                    }
                }}
            >
                <DialogTitle>{"Account Request Submitted"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-success-description">
                        {successDialog.message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSuccessDialogClose} autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
    //#endregion
}
